import { Injectable } from '@angular/core';
import { HttpHeaders } from "@angular/common/http";
import { HttpService } from "./httpService";
import { Config } from '../config/config';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthserviceService extends Config {

    constructor(private httpService: HttpService,) {
        super()
    }

    fetchMobileNumber() {
        let url = this.msisdnURL;
        console.log('url ++++++++++++++++++++++++++++++++++++', url);
        let httpHeaders = new HttpHeaders({
        });
        let options = {
            headers: httpHeaders,
            responseType: 'XML'
        }
        return this.httpService.sendGetRequest(url, options);
    }

    // getData(endpoint) {
    //     var url = environment.serviceUrl + endpoint;
    //     let httpHeaders = new HttpHeaders({
    //         "Content-Type": "application/json",
    //     });
    //     console.log("httpheader ", httpHeaders)
    //     let options = {
    //         headers: httpHeaders
    //     }
    //     return this.httpService.sendGetRequest(url, options);
    // }

    // postData(json, endpoint) {
    //     console.log("Json", json)
    //     var requestId = Number(new Date());
    //     var url = environment.serviceUrl + endpoint + "?requestId=" + requestId;
    //     //let token = environment.customersupportKey;

    //     let postData = json;

    //     let httpHeaders = new HttpHeaders({
    //         "Content-Type": "application/json",
    //         "accept": "application/json"
    //         //  "X-Api-Key": token,
    //         // "X-Access-Token": access_token
    //     });
    //     console.log("httpheader ", httpHeaders)
    //     let options = {
    //         headers: httpHeaders
    //     }
    //     //return this.httpService.sendPostRequest2(url,postData,options)
    //     return this.httpService.sendPostRequestData(url, postData, options)
    // }

    // checkSubscrbeUser(endpoint) {

    //     var url = environment.serviceUrl + endpoint;
    //     //let token = environment.customersupportKey;

    //     let httpHeaders = new HttpHeaders({
    //         "Content-Type": "application/json",
    //         //  "X-Api-Key": token,
    //         // "X-Access-Token": access_token
    //     });
    //     console.log("httpheader ", httpHeaders)
    //     let options = {
    //         headers: httpHeaders
    //     }
    //     //return this.httpService.sendPostRequest2(url,postData,options)
    //     return this.httpService.sendGetRequest(url, options)
    // }




}
